import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolumeOn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M26.9997 0.333374C12.2723 0.333374 0.333008 12.2737 0.333008 27.003C0.333008 41.7322 12.2723 53.6726 26.9997 53.6726C41.7271 53.6726 53.6663 41.7322 53.6663 27.003C53.6663 12.2737 41.7271 0.333374 26.9997 0.333374Z",
			fill: "#212121"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6831 17.3484C26.2192 17.1861 25.709 17.3368 25.3959 17.7195L21.082 23.0887H18.1596C17.5218 23.0887 17 23.6105 17 24.2484V30.0466C17 30.6844 17.5218 31.2062 18.1596 31.2062H21.082L25.3959 36.5754C25.6162 36.8537 25.9525 37.0045 26.3004 37.0045C26.4279 37.0045 26.5555 36.9813 26.6831 36.9349C27.1469 36.7726 27.46 36.3319 27.46 35.8448V18.4501C27.46 17.9631 27.1469 17.5224 26.6831 17.36V17.3484Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7559 18.1719C29.7559 18.6937 30.0922 19.1576 30.6024 19.2851C34.1161 20.178 36.7138 23.3555 36.7138 27.1475C36.7138 30.9396 34.1161 34.117 30.6024 35.01C30.1038 35.1375 29.7559 35.6014 29.7559 36.1232C29.7559 36.877 30.4632 37.4452 31.1938 37.2597C35.6933 36.1116 39.0331 32.0065 39.0331 27.1475C39.0331 22.2886 35.6933 18.1834 31.1938 17.0354C30.4632 16.8499 29.7559 17.4181 29.7559 18.1719Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7559 23.1352C29.7559 23.5527 29.9762 23.9238 30.3357 24.1441C31.3678 24.7471 32.0752 25.8604 32.0752 27.1476C32.0752 28.4348 31.3794 29.5481 30.3357 30.1511C29.9762 30.3598 29.7559 30.7425 29.7559 31.16C29.7559 32.0645 30.7416 32.6211 31.5301 32.1573C33.2464 31.1484 34.3945 29.2813 34.3945 27.1476C34.3945 25.0138 33.2464 23.1468 31.5301 22.1379C30.7416 21.674 29.7559 22.2307 29.7559 23.1352Z",
			fill: "white"
		})
	]
});
export default SvgVolumeOn;
